import {Grid, Stack, useTheme} from '@mui/material';
import {AppButton} from 'components/buttons';
import {useAddBoardItemComment} from 'hooks';
import React from 'react';

import {ActivityModel} from 'models';
import {useForm} from 'react-hook-form';
import {AppControlledEditor} from 'components/form/AppTextEditor';
import {hasTextContent} from 'global';
import {ItemDataResponse} from 'models/board';

export interface AddBoardItemCommentProps {
    selectedItem: ItemDataResponse;
    addComment: (comment: ActivityModel) => void;
}

export const AddBoardItemComment: React.FC<AddBoardItemCommentProps> = props => {
    const theme = useTheme();
    const {addTaskComment} = useAddBoardItemComment(props);
    const {control, handleSubmit, reset} = useForm<{comment: string}>({
        defaultValues: {comment: ''},
    });

    const subHandler = (value: {comment: string}) => {
        addTaskComment(value.comment);
        reset();
    };

    return (
        <div>
            <Grid
                container
                alignItems="center"
                spacing={1}
                sx={{
                    maxWidth: '100%',
                    borderColor: theme.palette.divider,
                }}
            >
                <Grid item xs={12}>
                    <Stack spacing={1}>
                        <AppControlledEditor
                            control={control}
                            scopeId={props.selectedItem.itemStatus?.boardId}
                            label={''}
                            rules={{
                                validate: value => hasTextContent(value) || '* Content is required',
                            }}
                            style={{border: '1px solid #d3d3d3'}}
                            name="comment"
                            key={'text-quill-editor'}
                        />
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <AppButton
                        sx={{
                            width: '100%',
                        }}
                        onClick={handleSubmit(subHandler)}
                    >
                        Add Comment
                    </AppButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default AddBoardItemComment;
